export type {
  BreadcrumbItemSlots,
  BreadcrumbItemBaseProps as BreadcrumbItemProps,
  BreadcrumbItemBaseState as BreadcrumbItemState,
} from '@fluentui/react-breadcrumb';
